document.addEventListener('DOMContentLoaded', function () {
  const bundle = document.querySelector('.bundle-builder');
  if (!bundle) return;

  const addButton = document.getElementById('BundleAddToCart');
  const swatches = bundle.querySelectorAll('.bundle-swatch');

  swatches.forEach((swatch) => {
    swatch.addEventListener('click', function () {
      const group = this.dataset.group;
      const groupSwatches = bundle.querySelectorAll(`.bundle-swatch[data-group="${group}"]`);

      groupSwatches.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      this.classList.add('is-active');
      this.setAttribute('aria-pressed', 'true');
    });
  });

  addButton.addEventListener('click', async function () {
    const fixedProducts = bundle.querySelectorAll('.bundle-included-item');
    const selectedGroup1 = bundle.querySelector('.bundle-swatch[data-group="1"].is-active');
    const selectedGroup2 = bundle.querySelector('.bundle-swatch[data-group="2"].is-active');

    if (fixedProducts.length < 2 || !selectedGroup1 || !selectedGroup2) {
      alert('Please complete the bundle selection.');
      return;
    }

    const bundleId = 'bundle_' + Date.now();
    const bundleName = bundle.dataset.bundleName || 'Bundle';

    const items = [
      {
        id: Number(fixedProducts[0].dataset.variantId),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_name: bundleName,
          _bundle_role: 'fixed_1'
        }
      },
      {
        id: Number(fixedProducts[1].dataset.variantId),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_name: bundleName,
          _bundle_role: 'fixed_2'
        }
      },
      {
        id: Number(selectedGroup1.dataset.variantId),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_name: bundleName,
          _bundle_role: 'choice_1'
        }
      },
      {
        id: Number(selectedGroup2.dataset.variantId),
        quantity: 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_name: bundleName,
          _bundle_role: 'choice_2'
        }
      }
    ];

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Failed to add bundle');

      window.location.href = '/cart';
    } catch (error) {
      console.error(error);
      alert('There was an issue adding the bundle.');
    }
  });
});